// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n#txdituContainer[data-v-658d39eb] {\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  font-family: \"微软雅黑\";\n}", ""]);
// Exports
module.exports = exports;
